const Items = document.querySelectorAll('.prices-page-v__item');

Items.forEach((btn) => {
  btn.addEventListener('click', () => {
    const pricesBottom = btn.querySelector('.prices-page-v__bottom');

    if (pricesBottom) {
      pricesBottom.classList.toggle('active');
    }

    const arrow = btn.querySelector('.prices-page-v__arrow-box');
    if (arrow) {
      arrow.classList.toggle('active');
    }
  });
});



// WEBPACK FOOTER //
// ./scripts/partials/accordion.js